































































































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { saveAs } from '@/web/utils/save-file';
import { formatDate } from '@/web/utils/format';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';

interface LocalState {
  search: string;
  date: DatePicker;
  tableFields: PaginatedTableField[];
}

export default Vue.extend({
  name: 'TipJar',
  components: {
    TopNav,
    NavItem,
  },
  data(): LocalState {
    return {
      search: '',
      status: '',
      date: {},
      tableFields: [
        {
          title: this.$t('TIP_JAR.TABLE.NAME') as string,
          name: 'full_name',
          cssClass: 'h5 m-0',
          ordering: 'student__first_name',
        },
        {
          title: this.$t('TIP_JAR.TABLE.EMAIL') as string,
          key: 'email',
          cssClass: 'h5 m-0',
          ordering: 'student__user__email',
        },
        {
          name: 'created',
          title: this.$t('TIP_JAR.TABLE.TIP_DATE') as string,
          ordering: 'created',
        },
        {
          name: 'amount_paid',
          title: this.$t('TIP_JAR.TABLE.AMOUNT_PAID') as string,
          cssClass: 'h5 m-0',
          ordering: 'amount_paid',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      tipJarStats: 'sale/tipJarStats',
      tipJarSettings: 'setting/tipJar',
    }),
    query(): {} {
      return {
        q: this.search,
        startDate: this.date?.startDate,
        endDate: this.date?.endDate,
      };
    },
    showEmpty(): boolean {
      const tipsTable = this.$store.state['tips-table'];
      if (tipsTable) {
        return tipsTable.perPage === 0 && !tipsTable.isLoading;
      }
      return false;
    },
  },
  methods: {
    formatDate(date: string): string {
      if (!date) return '';
      return formatDate(date, 'date-time');
    },
    async exportAll(): Promise<void> {
      const table = this.$refs.tipJarTable as any;
      const data = await this.$store.dispatch('sale/exportTips', {
        ...this.query,
        ordering: `${table.orderingDirection}${table.ordering}`,
      });
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'tip-history-export.csv');
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('sale/getTipJarStats');
      await this.$store.dispatch('setting/getTipJarInfo');
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: 'Failed to load tip jar statistics',
        text: errorToMessage(error?.response, `Request failed: ${error}`),
        duration: -1, // stay ON
      });
    }
  },
});
